import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import withIntl from '../../../lib/withIntl';
import '../SetupWizard.scss';
import SetupWizardGeneralStepPage from './SetupWizardGeneralStepPage';
import {handleCalibrateCollision} from '../../../stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';

const mapDispatchToProps = (dispatch) => ({
  setupWizardBusinessColisionCalibration: bindActionCreators(handleCalibrateCollision, dispatch),
});

function StepTwoSetupWizard({setupWizardBusinessColisionCalibration}) {
  const onButtonClick = () => setupWizardBusinessColisionCalibration();

  return <SetupWizardGeneralStepPage withImage={false} onButtonClick={onButtonClick} />;
}

StepTwoSetupWizard.propTypes = {
  setupWizardBusinessColisionCalibration: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(withIntl(StepTwoSetupWizard));
